export default __webpack_public_path__ + "static/Logo-new-LN-a66742d3fb93bcaaf36e50a962e14fdf.png";